export default "__VITE_ASSET__C5a5TS9U__"